import { Host, h } from '@stencil/core';
import { navigateWithRouter } from '../utils';
import { store as pesRouterStore } from '../pes-router-store';
import PesRoute from '../pes-route';
export class PesRouterLink {
  constructor() {
    this.onLinkClick = (e) => {
      var _a;
      if (!pesRouterStore.get('bypass')) {
        e.preventDefault();
      }
      (_a = this.saveInIndexDB) === null || _a === void 0 ? void 0 : _a.call(this, e);
      navigateWithRouter(this.route, e.currentTarget);
    };
    this.page = undefined;
    this.pageId = undefined;
    this.tabId = undefined;
    this.url = undefined;
    this.target = undefined;
    this.urlSearchParams = undefined;
    this.saveInIndexDB = undefined;
  }
  connectedCallback() {
    const firstChild = this.pesLinkElement.children[0];
    if (firstChild) {
      this.child = firstChild;
      if (!this.url) {
        this.child.addEventListener('click', this.onLinkClick);
      }
    }
  }
  componentWillLoad() {
    const firstChild = this.pesLinkElement.children[0];
    if (firstChild) {
      this.child = firstChild;
      if (this.url) {
        this.child.href = this.url;
      }
      else {
        this.route = new PesRoute({
          page: this.page,
          pageId: this.pageId,
          tabId: this.tabId,
          searchParams: this.urlSearchParams,
        });
        this.child.href = this.route.url;
      }
      if (this.target) {
        this.child.target = this.target;
      }
    }
  }
  disconnectedCallback() {
    this.child.removeEventListener('click', this.onLinkClick);
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
  static get is() { return "pes-router-link"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-router-link.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-router-link.css"]
    };
  }
  static get properties() {
    return {
      "page": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "PesPageType",
          "resolved": "\"\" | \"all-products\" | \"category\" | \"comparator\" | \"product\" | \"product-cart\" | \"range\" | \"subcategory\"",
          "references": {
            "PesPageType": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "range."
            }],
          "text": "Application page."
        },
        "attribute": "page",
        "reflect": false
      },
      "pageId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "55432."
            }],
          "text": "Page id if exists."
        },
        "attribute": "page-id",
        "reflect": false
      },
      "tabId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "documents"
            }],
          "text": "Tab id for scroll to a tab on PDP."
        },
        "attribute": "tab-id",
        "reflect": false
      },
      "url": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "http://some.domain/some/path#some-hash?some=query"
            }],
          "text": "If url already composed and should be used instead of page and pageId.\nUse page and pageId or url property."
        },
        "attribute": "url",
        "reflect": false
      },
      "target": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "_blank"
            }],
          "text": "Target attribute specifies where to open the linked document."
        },
        "attribute": "target",
        "reflect": false
      },
      "urlSearchParams": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSearchParams",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "TSearchParams": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "{ filter: \"business-10-smart-grid\" }"
            }],
          "text": "Object with url search parameters if exists"
        }
      },
      "saveInIndexDB": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(e) => void",
          "resolved": "(e: any) => void",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Callback that allow to save information about breadcrumbs in IndexDB"
        }
      }
    };
  }
  static get elementRef() { return "pesLinkElement"; }
}
